import styled from 'styled-components';

export default styled.div`
  grid-area: sidebar;
  margin: ${props => props.theme.header.height} 1.5rem 1rem;
`;
